import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import BranchOffices from './BranchOffices'
import CostCenters from './CostCenters'
export const SubViewFactoryLabels = {
  branch: 'branch',
  costCenter: 'costCenter',
}

const SubViewFactoryOptions = {
  branch: BranchOffices,
  costCenter: CostCenters,
}
const SubViewFactory = ({ view }) => {
  const Component = useMemo(() => SubViewFactoryOptions[view] || null)
  return Component ? <Component /> : null
}

SubViewFactory.propTypes = {
  view: PropTypes.string,
}

export default SubViewFactory
